import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterListingPage_template} from "./filterListingPage_template";
import {pinnedListingPages_template} from "./pinnedListingPages_template";
import {HubPagePinnedHubPage} from "../../utils/types/listing_page";
import {imagePicker_template} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import {imagePickerHelper} from "../../../vendor/valnet/valnet_imagePicker/js/modules/imagePickerHelper";
import {imageWidget_template} from "./imageWidget_template";
import {DragAndDropHandler} from "../../utils/DragAndDropHandler";
import {filterArticle_template} from "./filterArticle_template";
import {filterSingleDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template";
import Title from "amcharts/Title";
import {multipleSelector_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template';
import {vignettePicker_template} from "./vignettePicker_template";

declare var ko: any;

export class configSidebar_template extends vnTemplate {

    protected pinnedListingPages: pinnedListingPages_template;
    public imagePicker: imagePicker_template;
    protected imagePickerHelper: imagePickerHelper;
    public imageWidget: imageWidget_template;
    public articleFilter: filterArticle_template;
    public filterCategory: multipleSelector_template;
    protected sidebarWidgetDatePicker: filterSingleDate_template;
    public vignettePicker: vignettePicker_template;

    protected getTemplateHtml(): string {
        return `
            <div class="w-form pinned-articles">
                <div class="form-header">
                    <input type="hidden">

                    <h3 class="form-title ">General</h3>

                </div>

                <div class="form-body">
                    <table class="list-action">
                        <thead>
                            <tr>
                                <th></th>
                                <th><span>home page</span></th>
                                <th><span>article page</span></th>
                                <th><span>hub page</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td></td>
                                <td class="align-center">
                                    <button data-bind="disable: !permissions()['sidebar_trending'].update, event: {click: toggleSelectAll('home_page', true)}" class="btn-form" type="button">Select all</button>
                                    <button data-bind="disable: !permissions()['sidebar_trending'].update, event: {click: toggleSelectAll('home_page', false)}" class="btn-form" type="button">Deselect all</button>
                                </td>
                                <td class="align-center">
                                    <button data-bind="disable: !permissions()['sidebar_trending'].update, event: {click: toggleSelectAll('article_page', true)}" class="btn-form" type="button">Select all</button>
                                    <button data-bind="disable: !permissions()['sidebar_trending'].update, event: {click: toggleSelectAll('article_page', false)}" class="btn-form" type="button">Deselect all</button>
                                </td>
                                <td class="align-center">
                                    <button data-bind="disable: !permissions()['sidebar_trending'].update, event: {click: toggleSelectAll('listing_page', true)}" class="btn-form" type="button">Select all</button>
                                    <button data-bind="disable: !permissions()['sidebar_trending'].update, event: {click: toggleSelectAll('listing_page', false)}" class="btn-form" type="button">Deselect all</button>
                                </td>
                            </tr>
                            <tr>
                                <td><span class="form-label">Popular Section</span></td>
                                <td>
                                    <div class="form-group">
                                        <div class="form-check-inline" style="width: auto;">
                                            <input type="checkbox" id="show-popular-section-on-home-page" data-bind="disable: !permissions()['sidebar_trending'].update, checked: isPopularSectionEnabledOnHomePage">
                                            <label for="show-popular-section-on-home-page" class="form-label icon i-check">Enabled</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-group">
                                        <div class="form-check-inline" style="width: auto;">
                                            <input type="checkbox" id="show-popular-section-on-article-page" data-bind="disable: !permissions()['sidebar_trending'].update, checked: isPopularSectionEnabledOnArticlePage">
                                            <label for="show-popular-section-on-article-page" class="form-label icon i-check">Enabled</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-group">
                                        <div class="form-check-inline" style="width: auto;">
                                            <input type="checkbox" id="show-popular-section-on-listing-page" data-bind="disable: !permissions()['sidebar_trending'].update, checked: isPopularSectionEnabledOnListingPage">
                                            <label for="show-popular-section-on-listing-page" class="form-label icon i-check">Enabled</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><span class="form-label">Trending Now Section</span></td>
                                <td>
                                    <div class="form-group">
                                        <div class="form-check-inline" style="width: auto;">
                                            <input type="checkbox" id="show-trending-section-on-home-page" data-bind="disable: !permissions()['sidebar_trending'].update, checked: isTrendingNowSectionEnabledOnHomePage">
                                            <label for="show-trending-section-on-home-page" class="form-label icon i-check">Enabled</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-group" style="gap: 30px;">
                                        <div class="form-check-inline" style="width: auto;">
                                            <input type="checkbox" id="show-trending-section-on-article-page" data-bind="disable: !permissions()['sidebar_trending'].update, checked: isTrendingNowSectionEnabledOnArticlePage">
                                            <label for="show-trending-section-on-article-page" class="form-label icon i-check">Enabled</label>
                                        </div>
                                        <div class="form-check-inline" style="width: auto;">
                                            <input type="checkbox" id="with-tag-interaction-on-article-page" data-bind="disable: !permissions()['sidebar_trending'].update, checked: isTrendingNowWithTagInteractionOnArticlePage">
                                            <label for="with-tag-interaction-on-article-page" class="form-label icon i-check">With Tag Interaction</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-group">
                                        <div class="form-check-inline" style="width: auto;">
                                            <input type="checkbox" id="show-trending-section-on-listing-page" data-bind="disable: !permissions()['sidebar_trending'].update, checked: isTrendingNowSectionEnabledOnListingPage">
                                            <label for="show-trending-section-on-listing-page" class="form-label icon i-check">Enabled</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="form-footer">
                      <button data-bind="disable: !permissions()['sidebar_trending'].update, event: { click: onClickCancelGeneralConfig }" title="There will be no changes made" class="btn " type="button">Cancel</button>
                      <button data-bind="disable: !permissions()['sidebar_trending'].update, event: { click: onClickSaveGeneralConfig }" class="btn highlight" type="button">Save</button>
                   </div>
                </div>
            </div>

            <div class="w-form pinned-articles">
                <div class="form-header">
                    <input type="hidden">
                    <h3 class="form-title icon i-pin-choice">Pinned Article</h3>
                </div>
                <div class="form-body">
                    <table class="list-action">
                        <thead>
                            <tr>
                                <th><span>home page</span></th>
                                <th><span>article page</span></th>
                                <th><span>hub page</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div class="form-group">
                                        <div class="form-check-inline" style="width: auto;">
                                            <input type="checkbox" id="show-pinned-article-on-home-page" data-bind="checked: isPinnedArticleEnabledOnHomePage">
                                            <label for="show-pinned-article-on-home-page" class="form-label icon i-check">Enable</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-group">
                                        <div class="form-check-inline" style="width: auto;">
                                            <input type="checkbox" id="show-pinned-article-on-article-page" data-bind="checked: isPinnedArticleEnabledOnArticlePage">
                                            <label for="show-pinned-article-on-article-page" class="form-label icon i-check">Enable</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="form-group">
                                        <div class="form-check-inline" style="width: auto;">
                                            <input type="checkbox" id="show-pinned-article-on-listing-page" data-bind="checked: isPinnedArticleEnabledOnListingPage">
                                            <label for="show-pinned-article-on-listing-page" class="form-label icon i-check">Enable</label>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div class="form-group">
                        <div>
                            <label class="form-label icon i-title">Section Title</label>
                            <input type="text" class="input-text" data-bind="value: pinnedArticleSectionTitle"/>
                        </div>
                    </div>

                    <div class="form-group cleared border">
                        <div>
                            <label class="form-label icon i-article">Article</label>
                           ${this.articleFilter.getHtmlBuild()}
                        </div>
                        <div>
                            <label class="form-label icon i-overwrite">Alternate Title</label>
                            <input type="text" class="input-text" data-bind="value: pinnedArticleAlternateTitle"/>
                        </div>


                    </div>

                    <div class="form-group row">
                        ${this.filterCategory.getHtmlBuild()}
                        <button class="btn highlight" type="button" data-bind="event: { click: onClickAddPinnedArticle }">Add Pinned Article</button>
                    </div>
                    <div class="form-group row">
                            <div class="form-group w-radio" data-bind="foreach: selectedCategories">
                                <div class="btn-selection category-element">
                                    <label class="form-label" data-bind="text: $data.name, attr: { for: 'category_' + $data.id }" style="margin: 0;"></label>
                                    <button class="icon i-x-after" type="button" data-bind="click: $parent.onClickDeleteSelectedCategory"></button>
                                </div>
                            </div>
                    </div>

                    <div class="form-group cleared border">
                        <table class="list-action">
                            <thead>
                                <tr style="white-space: pre;">
                                    <th><span>Position</span></th>
                                    <th><span>Section Title</span></th>
                                    <th><span>Alternate Title</span></th>
                                    <th><span>Article</span></th>
                                    <th><span>Categories</span></th>
                                </tr>
                            </thead>
                            <tbody data-bind="foreach: pinnedArticles">
                                <tr>
                                    <td>
                                        <button style="margin: 0; display: inline-block; margin-right: 5px;" class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedArticle }"><span class="hidden-text">Delete</span></button>
                                        <span data-bind="text: ($index() + 1)"></span>
                                    </td>
                                    <td>
                                        <span style="text-transform: none" data-bind="text: sectionTitle"></span>
                                    </td>
                                    <td>
                                        <span style="text-transform: none" data-bind="text: alternateTitle"></span>
                                    </td>
                                    <td>
                                        <span style="text-transform: none" data-bind="text: articleTitle"></span>
                                    </td>
                                    <td>
                                        <!-- ko if: categories && categories.length -->
                                        <span style="text-transform: none" data-bind="text: (categories.map(function(c){return c.name || c;}).join(', '))"></span>
                                        <!-- /ko -->
                                        <!-- ko if: categories.length == 0 -->
                                        <span style="text-transform: none">No categories</span>
                                        <!-- /ko -->
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="form-footer">
                      <button data-bind="event: { click: onClickCancelPinnedArticleConfig }" title="There will be no changes made" class="btn " type="button">Cancel</button>
                      <button data-bind="event: { click: onClickSavePinnedArticleConfig }" class="btn highlight" type="button">Save</button>
                   </div>
                </div>
            </div>

            <div class="ww-form side-by-side">
                <div class="w-form  pinned-articles">
                    <div class="form-header">
                        <input type="hidden">

                        <h3 class="form-title icon i-poll">Pinned Widget</h3>

                    </div>

                    <div class="form-body">
                        <table class="list-action">
                            <thead>
                                <tr>
                                    <th><span>home page</span></th>
                                    <th><span>article page</span></th>
                                    <th><span>hub page</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="form-group">
                                            <div class="form-check-inline" style="width: auto;">
                                                <input type="checkbox" id="show-widget-section-on-home-page" data-bind="checked: isPinnedWidgetEnabledOnHomePage">
                                                <label for="show-widget-section-on-home-page" class="form-label icon i-check">Enable</label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <div class="form-check-inline" style="width: auto;">
                                                <input type="checkbox" id="show-widget-section-on-article-page" data-bind="checked: isPinnedWidgetEnabledOnArticlePage">
                                                <label for="show-widget-section-on-article-page" class="form-label icon i-check">Enable</label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <div class="form-check-inline" style="width: auto;">
                                                <input type="checkbox" id="show-widget-section-on-listing" data-bind="checked: isPinnedWidgetEnabledOnListingPage">
                                                <label for="show-widget-section-on-listing" class="form-label icon i-check">Enable</label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                       <div class="form-group">
                            <div class="form-check-inline width-auto">
                                <input type="radio" id="sidebar-widget-poll" name="sidebar-widget-type" value="poll" data-bind="checked: widgetType, event: { change: onWidgetTypeChanged }">
                                <label for="sidebar-widget-poll">Poll</label>
                            </div>
                            <div class="form-check-inline width-auto">
                                <input type="radio" id="sidebar-widget-quiz" name="sidebar-widget-type" value="quiz" data-bind="checked: widgetType, event: { change: onWidgetTypeChanged }">
                                <label for="sidebar-widget-quiz">Quiz</label>
                            </div>
                            <div class="form-check-inline width-auto">
                                <input type="radio" id="sidebar-widget-vignette" name="sidebar-widget-type" value="vignette" data-bind="checked: widgetType, event: { change: onWidgetTypeChanged }">
                                <label for="sidebar-widget-vignette">Vignettes</label>
                            </div>
                       </div>
                       <!-- ko if: widgetType() !== 'vignette' -->
                       <div class="form-group">
                                 <div class="w-spec-search icon i-auto-complete" data-bind="css: {
                                     'is-suggestions-open': isShowWidgetSuggestions,
                                     'i-poll-a': widgetType() === 'poll'
                                 }">
                                    <!-- ko if: widgetType() === 'quiz' -->
                                    <svg aria-hidden="true" viewBox="0 0 24 24">
                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
                                    </svg>
                                    <!-- /ko -->
                                    <!-- ko if: widgetType() === 'vignette' -->
                                    <svg aria-hidden="true" viewBox="0 0 100 100">
                                        <path d="M86.1,7.4H13.8C6.2,7.4,0,14.1,0,22.4v55.5c0,8.3,6.2,15,13.9,15h72.3c7.6,0,13.9-6.7,13.9-15V22.4c0-8.3-6.2-15-13.9-15ZM13.2,28.6c0-4.1,3.3-7.4,7.4-7.4h16.3c4.1,0,7.4,3.3,7.4,7.4v29.2c0,4.1-3.3,7.4-7.4,7.4h-16.3c-4.1,0-7.4-3.3-7.4-7.4v-29.2ZM84.1,76.5H16.3c-1.7,0-3.1-1.4-3.1-3.1s1.4-3.1,3.1-3.1h67.7c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1ZM84.2,64.4h-32.1c-1.6,0-3-1.4-3-3.1s1.3-3.1,3-3.1h32.1c1.6,0,3,1.4,3,3.1s-1.3,3.1-3,3.1ZM84.2,52.3h-32.1c-1.6,0-3-1.4-3-3.1s1.3-3.1,3-3.1h32.1c1.6,0,3,1.4,3,3.1s-1.3,3.1-3,3.1ZM84.2,40.2h-32.1c-1.6,0-3-1.4-3-3.1s1.3-3.1,3-3.1h32.1c1.6,0,3,1.4,3,3.1s-1.3,3.1-3,3.1ZM84.2,28.2h-32.1c-1.6,0-3-1.4-3-3.1s1.3-3.1,3-3.1h32.1c1.6,0,3,1.4,3,3.1s-1.3,3.1-3,3.1Z"/>
                                    </svg>
                                    <!-- /ko -->
                                    <input class="input-text" type="text"
                                        data-bind="attr: { placeholder: widgetSearchPlaceholder },
                                         event:{
                                             keyup: () => onChangeWidget($data.widgetName()),
                                             blur: onWidgetSearchBlur
                                         },
                                         textInput: widgetName, valueUpdate: 'afterkeydown'"
                                        />
                                    <ul class="form-auto-list" data-bind="foreach: widgetOptions, visible: isShowWidgetSuggestions">
                                        <li class="form-auto-item" data-bind="click: $parent.onSelectWidget">
                                            <span class="title" data-bind="text: name"></span>
                                            <span class="date">ID: <span data-bind="text: id"></span></span>
                                        </li>
                                    </ul>
                                    <button class="close-btn icon i-x-after is-showing" type="button"
                                        data-bind="visible: idWidget, event: { click: onClearWidget }">
                                        <span class="hidden-text">Clear selected widget</span>
                                    </button>
                                </div>
                       </div>
                       <!-- /ko -->
                       <!-- ko if: widgetType() === 'vignette' -->
                       <div class="form-group" style="display: flex; align-items: center; gap: 2rem; justify-content: flex-start;">
                            <button class="btn secondary" type="button" data-bind="event: { click: openVignettePicker }">Browse Vignettes</button>
                            <div style="display: flex; align-items: center; gap: 0.5rem;">
                                <span class="form-text" style="margin-bottom: 0;" data-bind="visible: idWidget, text: widgetName"></span>
                                <button class="close-btn icon i-x-after is-showing" type="button"
                                    data-bind="visible: idWidget, event: { click: onClearWidget }">
                                    <span class="hidden-text">Clear selected vignette</span>
                                </button>
                            </div>
                       </div>
                       <!-- /ko -->
                       <div class="form-group" data-bind="visible: idWidget">
                            <label class="form-label icon i-time">Expires at</label>
                            <div class="sidebar-widget-date-picker">
                                ${this.sidebarWidgetDatePicker.getHtmlBuild()}
                            </div>
                       </div>
                    </div>
                    <div class="form-footer">
                        <button data-bind="event: { click: onClickCancelPinnedWidget }" title="There will be no changes made" class="btn " type="button">Cancel</button>
                        <button data-bind="event: { click: onClickSavePinnedWidget }" class="btn highlight" type="button">Save</button>
                    </div>
                </div>
                <div class="w-form">
                    <div class="form-header">
                        <h3 class="form-title icon i-listing-page">Pinned Hub Pages</h3>
                    </div>
                    <div class="form-body pinned-articles">
                        <table class="list-action">
                            <thead>
                                <tr>
                                    <th><span>home page</span></th>
                                    <th><span>article page</span></th>
                                    <th><span>Hub page</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div class="form-group">
                                            <div class="form-check-inline" style="width: auto;">
                                                <input type="checkbox" id="show-lp-section-on-home-page" data-bind="checked: isPinnedListingPageEnabledOnHomePage">
                                                <label for="show-lp-section-on-home-page" class="form-label icon i-check">Enable</label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <div class="form-check-inline" style="width: auto;">
                                                <input type="checkbox" id="show-lp-section-on-article-page" data-bind="checked: isPinnedListingPageEnabledOnArticlePage">
                                                <label for="show-lp-section-on-article-page" class="form-label icon i-check">Enable</label>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <div class="form-check-inline" style="width: auto;">
                                                <input type="checkbox" id="show-lp-section-on-listing" data-bind="checked: isPinnedListingPageEnabledOnListingPage">
                                                <label for="show-lp-section-on-listing" class="form-label icon i-check">Enable</label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="form-group">
                            <div class="form-check-inline width-auto">
                                <input type="radio" id="emaki-hub-pages" name="pinned-hub-page-type-radio-group" value="emaki-hub-pages" data-bind="checked: pinnedHubPageType">
                                <label  for="emaki-hub-pages">Emaki Hub Pages</label>
                            </div>
                            <div class="form-check-inline width-auto">
                                <input type="radio" id="custom-pages" name="pinned-hub-page-type-radio-group" value="custom-pages" data-bind="checked: pinnedHubPageType">
                                <label for="custom-pages">Custom Pages</label>
                            </div>
                        </div>
                        <div class="form-group" data-bind="visible: pinnedHubPageType() == 'emaki-hub-pages'">
                            <hr>
                            ${this.pinnedListingPages.getHtmlBuild()}
                        </div>
                        <div data-bind="visible: pinnedHubPageType() == 'custom-pages'">
                            <div class="form-group">
                                <label class="form-label">Number of Position Lists</label>
                                <select class="input-select" data-bind="value: numberOfPositionLists">
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label class="form-label">List Title</label>
                                <input type="text" class="input-text" data-bind="value: customPageTitle1"/>
                            </div>
                            <div class="form-group">
                                <label class="form-label">More Linkout Title</label>
                                <input type="text" class="input-text" data-bind="value: customPageMoreLinkoutTitle1"/>
                            </div>
                            <div class="form-group">
                                <label class="form-label">More Linkout Url</label>
                                <input type="text" class="input-text" data-bind="value: customPageMoreLinkoutUrl1"/>
                            </div>
                            <div data-bind="visible: numberOfPositionLists() == 2">
                                <div class="form-group">
                                    <label class="form-label">List Title 2</label>
                                    <input type="text" class="input-text" data-bind="value: customPageTitle2"/>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">More Linkout Title 2</label>
                                    <input type="text" class="input-text" data-bind="value: customPageMoreLinkoutTitle2"/>
                                </div>
                                <div class="form-group">
                                    <label class="form-label">More Linkout Url 2</label>
                                    <input type="text" class="input-text" data-bind="value: customPageMoreLinkoutUrl2"/>
                                </div>
                            </div>
                            <div class="form-group">
                                <button data-bind="event: { click: onClickTogglePinnedCustomPageSection(true) }" class="btn highlight" type="button">Add Pinned Custom Page</button>
                            </div>
                            <div class="form-group " data-bind="foreach: pinnedCustomPageItems, childrenComplete : handleDragAndDrop($element, pinnedCustomPageItems ,'.entry')">
                                <div class="form-body w-pinned">
                                    <div class="pinned-form listingPage-pinned entry">
                                        <div class="pinned-drag icon i-drag">
                                            <span class="pinned-position" data-bind="text: ($index() + 1)"></span>
                                        </div>
                                        <div class="w-btn">
                                            <button class="btn border only-icon icon border i-edit" type="button" data-bind="event: { click: $parent.onClickEditPinnedCustomPageItem }"><span class="hidden-text">Edit</span></button>
                                            <button class="btn border only-icon icon border highlight i-delete" type="button" data-bind="event: { click: $parent.onClickDeletePinnedCustomPageItem }"><span class="hidden-text">Delete</span></button>
                                        </div>
                                        <div class="w-title">
                                            <span class="pinned-title">Card Title :<span data-bind="text: cardTitle"></span></span>
                                            <span class="pinned-title">Card Linkout :<span data-bind="text: cardLinkoutUrl"></span></span>
                                            <!-- ko if: cardImage && cardImage.url -->
                                            <div class="pinned-title"> Card Image:
                                                <img data-bind="attr: { src: cardImage.url + '?w=50&h=50', alt: cardImage.altText || 'Card image' }" style="width: 50px; height: 50px; object-fit: cover; margin-left: 5px;" />
                                            </div>
                                            <!-- /ko -->
                                            <span class="pinned-title">Card Description :<span data-bind="html: cardDescription"></span></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                   </div>

                   <div class="form-footer">
                      <button data-bind="event: { click: onClickCancelPinnedPageConfig }" title="There will be no changes made" class="btn " type="button">Cancel</button>
                      <button data-bind="event: { click: onClickSavePinnedPageConfig }" class="btn highlight" type="button">Save</button>
                   </div>
                </div>
            </div>
            <div data-bind="css: { 'is-visible': isAddPinnedCustomPageVisible }" class="w-lightbox light-theme">
                <div class="lightbox-content">
                    <div class="w-form w-form-large lightbox-form">
                        <div class="pinned-form">
                            <div class="form-header">
                                <h3 class="form-title">Add Pinned Custom Card</h3>
                                <button class="close-button icon i-close-2" data-bind="event: { click: onClickTogglePinnedCustomPageSection(false)}"></button>
                            </div>
                            <div class="w-form-body">

                                <div class="form-body">
                                    <div class="form-group">
                                        <label class="form-label">Card Title</label>
                                        <input type="text" class="input-text" data-bind="value: customCardTitle"/>
                                    </div>
                                    <div class="form-group">
                                        <label class="form-label">Card Linkout</label>
                                        <input type="text" class="input-text" data-bind="value: customCardLinkoutUrl"/>
                                    </div>
                                    <div class="form-group">
                                        <label for="" class="form-label">Image</label>
                                        <div style="width: 200px; height: 200px; overflow: hidden;">
                                            ${this.imageWidget.getHtmlBuild()}
                                        </div>
                                    </div>
                                </div>
                                <div class="form-body">
                                    <div class="form-group">
                                        <label class="form-label">Description</label>
                                        <textarea id="customCardDescription" class="input-textarea"></textarea>
                                    </div>
                                </div>
                            </div>

                            <div class="form-footer">
                                <button class="btn secondary" type="button" data-bind="event:{click: onClickAddPinnedCustomPageItem }, text: 'Add'">Add to List</button>
                                <button type="button" data-bind="event: { click: onClickTogglePinnedCustomPageSection(false)}" class="btn ">Cancel</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            ${this.imagePicker.getHtmlBuild()}
            ${this.vignettePicker.getHtmlBuild()}
        `;

    }

    protected initPartial(): void {

        this.sidebarWidgetDatePicker = new filterSingleDate_template('sidebarWidgetDate', this.getTemplateViewModel(), this.caller);
        this.sidebarWidgetDatePicker.toggleClearButton(true);
        this.sidebarWidgetDatePicker.setMinutesInterval(1);

        this.pinnedListingPages = new pinnedListingPages_template('pinnedListingPages', this.getTemplateViewModel(), this.caller);
        this.pinnedListingPages.setMaximum(2);

        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePickerHelper = new imagePickerHelper(this.imagePicker, this.caller.viewModel, this.caller.getVnAppZone(), this.caller);
        this.imageWidget = new imageWidget_template('custom_page_image', this.getTemplateViewModel(), this);
        this.imageWidget.setMode('single-select');
        this.imageWidget.setCaller(this.imagePickerHelper);

        this.articleFilter = new filterArticle_template('articleFilter', this.getTemplateViewModel(), this.caller);
        this.articleFilter.setShowDetails(true);
        this.articleFilter.setIsLoadingAnimationEnable(true);
        this.vignettePicker = new vignettePicker_template("sidebarVignettePicker", this.getTemplateViewModel(), this.caller);


        this.filterCategory = new multipleSelector_template("article_categoryFilter", this.getTemplateViewModel(), this.caller);
        this.filterCategory.setFilterContainerClass('margin-neg');
        this.filterCategory.setSelectAllEnabled(false);
        this.filterCategory.setSearchEnabled(true);
        this.filterCategory.setLabel("Categories");
    }

    protected getTemplateName(): string {
        return "configSidebar-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): string[] {

        return ["div", "config-homepage"];
    }

    protected buildViewModel(): any {

        const self = this;
        return {
            idWidget: ko.observable(null),
            widgetType: ko.observable('poll'),
            widgetName: ko.observable(''),
            vignetteVariables: ko.observableArray([]),
            vignetteReferences: ko.observableArray([]),
            widgetOptions: ko.observableArray([]),
            isShowWidgetSuggestions: ko.observable(false),
            widgetSearchPlaceholder: ko.observable('Poll Name'),
            idPoll: ko.observable(null),
            poll: ko.observable(null),
            pollTimeleft: ko.observable(null),
            pollHoursPinned: ko.observable(null),
            isWithTitle: ko.observable(false),
            pollDateCreated: ko.observable(null),
            pollName: ko.observable(""),
            pinnedPoll_options: ko.observableArray([]),
            isPopularSectionEnabledOnHomePage: ko.observable(false),
            isPopularSectionEnabledOnArticlePage: ko.observable(false),
            isPopularSectionEnabledOnListingPage: ko.observable(false),
            isTrendingNowSectionEnabledOnHomePage: ko.observable(false),
            isTrendingNowSectionEnabledOnArticlePage: ko.observable(false),
            isTrendingNowWithTagInteractionOnArticlePage: ko.observable(false),
            isTrendingNowSectionEnabledOnListingPage: ko.observable(false),
            isPinnedPollEnabledOnHomePage: ko.observable(false),
            isPinnedPollEnabledOnArticlePage: ko.observable(false),
            isPinnedPollEnabledOnListingPage: ko.observable(false),
            isPinnedWidgetEnabledOnHomePage: ko.observable(false),
            isPinnedWidgetEnabledOnArticlePage: ko.observable(false),
            isPinnedWidgetEnabledOnListingPage: ko.observable(false),
            isPinnedListingPageEnabledOnHomePage: ko.observable(false),
            isPinnedListingPageEnabledOnArticlePage: ko.observable(false),
            isPinnedListingPageEnabledOnListingPage: ko.observable(false),
            openVignettePicker: () => this.caller.openSidebarVignettePicker(),
            pinnedHubPageType: ko.observable("emaki-hub-pages"),
            numberOfPositionLists: ko.observable(1),
            isAddPinnedCustomPageVisible: ko.observable(false),
            customPageTitle1: ko.observable(''),
            customPageTitle2: ko.observable(''),
            customPageMoreLinkoutTitle1: ko.observable(''),
            customPageMoreLinkoutUrl1: ko.observable(''),
            customPageMoreLinkoutTitle2: ko.observable(''),
            customPageMoreLinkoutUrl2: ko.observable(''),
            customCardTitle: ko.observable(''),
            customCardLinkoutUrl: ko.observable(''),
            pinnedCustomPageItems: ko.observableArray([]),
            cardEdited: ko.observable(null),
            isPinnedArticleEnabledOnHomePage: ko.observable(false),
            isPinnedArticleEnabledOnArticlePage: ko.observable(false),
            isPinnedArticleEnabledOnListingPage: ko.observable(false),
            pinnedArticleAlternateTitle: ko.observable(''),
            pinnedArticleSectionTitle: ko.observable(''),
            pinnedArticles: ko.observableArray([]),
            selectedCategories : ko.observableArray([]),
            categories: ko.observableArray([]),
            permissions: ko.observableArray(this.initPermissions(['sidebar_trending'])),
            onClickAddPinnedArticle: () => {
                self.onClickAddPinnedArticle();
            },
            onClickDeletePinnedArticle: (data) => {
                self.onClickDeletePinnedArticle(data);
            },
            onClickCancelPinnedPoll() {
                self.onClickCancelPinnedPoll();
            },
            onClickCancelPinnedWidget() {
                self.onClickCancelPinnedWidget();
            },
            onClickCancelGeneralConfig() {
                self.onClickCancelGeneralConfig();
            },
            onClickDeletePinnedPoll(data, event) {
                self.onClickDeletePinnedPoll();
            },
            onClickSavePinnedPoll(data, event) {
                self.onClickSavePinnedPoll();
            },
            onClickSavePinnedWidget() {
                self.onClickSavePinnedWidget();
            },
            onSelectWidget(widget: any) {
                self.selectWidget(widget);
            },
            onClearWidget() {
                self.clearWidget();
            },
            onWidgetSearchBlur() {
                self.onWidgetSearchBlur();
            },
            onClickSaveGeneralConfig(data, event) {
                self.onClickSaveGeneralConfig();
            },
            onChangePoll(data) {
                self.onChangePoll(data);
            },
            onSelectedPoll() {
                self.onSelectedPoll();
            },
            onChangeWidget() {
                self.onChangeWidget();
            },
            onSelectedWidget() {
                self.onSelectedWidget();
            },
            onWidgetTypeChanged(data, event) {
                self.onWidgetTypeChanged(event && event.target ? event.target.value : null);
            },
            onClickCancelPinnedPageConfig: () => {
                self.onClickCancelPinnedPageConfig();
            },
            onClickSavePinnedPageConfig: () => {
                self.onClickSavePinnedPageConfig();
            },
            onClickCancelPinnedArticleConfig: () => {
                self.onClickCancelPinnedArticleConfig();
            },
            onClickSavePinnedArticleConfig: () => {
                self.onClickSavePinnedArticleConfig();
            },
            toggleSelectAll: (col, checked) => {
                self.toggleSelectAll(col, checked);
            },
            onClickTogglePinnedCustomPageSection: (data) => {
                self.onClickTogglePinnedCustomPageSection(data);
            },
            onClickAddPinnedCustomPageItem: () => {
                self.onClickAddPinnedCustomPageItem();
            },
            onClickDeletePinnedCustomPageItem: (data) => {
                self.onClickDeletePinnedCustomPageItem(data);
            },
            onClickEditPinnedCustomPageItem: (data) => {
                self.onClickEditPinnedCustomPageItem(data);
            },
            handleDragAndDrop(element, currentObservableArray, childrenSelector) {
                self.handleDragAndDrop(element, currentObservableArray, childrenSelector);
            },

            onClickDeleteSelectedCategory : (category) => {
                self.onClickDeleteSelectedCategory(category);
            }
        };
    }

    protected toggleSelectAll(col, checked) {

        switch (col) {
            case 'home_page':
                this.getTemplateViewModel().isPopularSectionEnabledOnHomePage(checked);
                this.getTemplateViewModel().isTrendingNowSectionEnabledOnHomePage(checked);
                break;
            case 'article_page':
                this.getTemplateViewModel().isPopularSectionEnabledOnArticlePage(checked);
                this.getTemplateViewModel().isTrendingNowSectionEnabledOnArticlePage(checked);
                this.getTemplateViewModel().isTrendingNowWithTagInteractionOnArticlePage(checked);
                break;

            case 'listing_page':
                this.getTemplateViewModel().isPopularSectionEnabledOnListingPage(checked);
                this.getTemplateViewModel().isTrendingNowSectionEnabledOnListingPage(checked);
                break;

        }
    }

    public setPinnedPoll(pinnedPoll) {

        if (pinnedPoll.poll != null) {
            this.getTemplateViewModel().idPoll(pinnedPoll.poll.id);
            this.getTemplateViewModel().pollName(pinnedPoll.poll.name);
            this.getTemplateViewModel().pollTimeleft(pinnedPoll.timeLeft);
            this.getTemplateViewModel().isWithTitle(pinnedPoll.isWithTitle);
        }

    }

    public setPinnedWidget(widgets) {
        const widget = widgets && widgets.length ? widgets[0] : null;
        const vm = this.getTemplateViewModel();
        if (!widget) {
            vm.idWidget(null);
            vm.widgetName('');
            vm.vignetteVariables([]);
            vm.vignetteReferences([]);
            this.setWidgetDateExpires(null);
            vm.isShowWidgetSuggestions(false);
            return;
        }

        vm.idWidget(widget.idWidget);
        vm.widgetType(widget.widgetType);
        vm.widgetName(widget.name || `${widget.widgetType} #${widget.idWidget}`);
        vm.vignetteVariables(widget.vignetteVariables || []);
        vm.vignetteReferences(widget.vignetteReferences || []);
        this.setWidgetDateExpires(widget.dateExpires);
        vm.pollTimeleft(widget.timeLeft || 'Never expires');
        this.updateWidgetSearchPlaceholder();
    }

    public isPinnedWidgetEnabledOnHomePage(value) {
        this.getTemplateViewModel().isPinnedWidgetEnabledOnHomePage(value);
    }

    public isPinnedWidgetEnabledOnArticlePage(value) {
        this.getTemplateViewModel().isPinnedWidgetEnabledOnArticlePage(value);
    }

    public isPinnedWidgetEnabledOnListingPage(value) {
        this.getTemplateViewModel().isPinnedWidgetEnabledOnListingPage(value);
    }

    public isPopularSectionEnabled(isPopularSectionEnabledOnHomePage) {
        this.getTemplateViewModel().isPopularSectionEnabledOnHomePage(isPopularSectionEnabledOnHomePage);
    }

    public isPopularSectionEnabledOnHomePage(isPopularSectionEnabledOnHomePage) {
        this.getTemplateViewModel().isPopularSectionEnabledOnHomePage(isPopularSectionEnabledOnHomePage);
    }

    public isPopularSectionEnabledOnArticlePage(isPopularSectionEnabledOnArticlePage) {
        this.getTemplateViewModel().isPopularSectionEnabledOnArticlePage(isPopularSectionEnabledOnArticlePage);
    }

    public isPopularSectionEnabledOnListingPage(isPopularSectionEnabledOnListingPage) {
        this.getTemplateViewModel().isPopularSectionEnabledOnListingPage(isPopularSectionEnabledOnListingPage);
    }

    public isTrendingNowSectionEnabledOnHomePage(isTrendingNowSectionEnabledOnHomePage) {
        this.getTemplateViewModel().isTrendingNowSectionEnabledOnHomePage(isTrendingNowSectionEnabledOnHomePage);
    }

    public isTrendingNowSectionEnabledOnArticlePage(isTrendingNowSectionEnabledOnArticlePage) {
        this.getTemplateViewModel().isTrendingNowSectionEnabledOnArticlePage(isTrendingNowSectionEnabledOnArticlePage);
    }

    public isTrendingNowWithTagInteractionOnArticlePage(isTrendingNowWithTagInteractionOnArticlePage) {
        this.getTemplateViewModel().isTrendingNowWithTagInteractionOnArticlePage(isTrendingNowWithTagInteractionOnArticlePage);
    }

    public isTrendingNowSectionEnabledOnListingPage(isTrendingNowSectionEnabledOnListingPage) {
        this.getTemplateViewModel().isTrendingNowSectionEnabledOnListingPage(isTrendingNowSectionEnabledOnListingPage);
    }

    public isPinnedPollEnabledOnHomePage(isPinnedPollEnabledOnHomePage) {
        this.getTemplateViewModel().isPinnedPollEnabledOnHomePage(isPinnedPollEnabledOnHomePage);
    }

    public isPinnedPollEnabledOnArticlePage(isPinnedPollEnabledOnArticlePage) {
        this.getTemplateViewModel().isPinnedPollEnabledOnArticlePage(isPinnedPollEnabledOnArticlePage);
    }

    public isPinnedPollEnabledOnListingPage(isPinnedPollEnabledOnListingPage) {
        this.getTemplateViewModel().isPinnedPollEnabledOnListingPage(isPinnedPollEnabledOnListingPage);
    }

    public isPinnedListingPageEnabledOnHomePage(isPinnedListingPageEnabledOnHomePage) {
        this.getTemplateViewModel().isPinnedListingPageEnabledOnHomePage(isPinnedListingPageEnabledOnHomePage);
    }

    public isPinnedListingPageEnabledOnArticlePage(isPinnedListingPageEnabledOnArticlePage) {
        this.getTemplateViewModel().isPinnedListingPageEnabledOnArticlePage(isPinnedListingPageEnabledOnArticlePage);
    }

    public isPinnedListingPageEnabledOnListingPage(isPinnedListingPageEnabledOnListingPage) {
        this.getTemplateViewModel().isPinnedListingPageEnabledOnListingPage(isPinnedListingPageEnabledOnListingPage);
    }

    public isPinnedArticleEnabledOnHomePage(isPinnedArticleEnabledOnHomePage) {
        this.getTemplateViewModel().isPinnedArticleEnabledOnHomePage(isPinnedArticleEnabledOnHomePage);
    }

    public isPinnedArticleEnabledOnArticlePage(isPinnedArticleEnabledOnArticlePage) {
        this.getTemplateViewModel().isPinnedArticleEnabledOnArticlePage(isPinnedArticleEnabledOnArticlePage);
    }

    public isPinnedArticleEnabledOnListingPage(isPinnedArticleEnabledOnListingPage) {
        this.getTemplateViewModel().isPinnedArticleEnabledOnListingPage(isPinnedArticleEnabledOnListingPage);
    }

    public setPinnedArticleAlternateTitle(pinnedArticleAlternateTitle) {
        this.getTemplateViewModel().pinnedArticleAlternateTitle(pinnedArticleAlternateTitle);
    }

    public setPinnedArticleSectionTitle(pinnedArticleSectionTitle) {
        this.getTemplateViewModel().pinnedArticleSectionTitle(pinnedArticleSectionTitle);
    }

    public getPinnedPollViewModel() {

        return {
            idPoll: this.getTemplateViewModel().idPoll,
            hoursPinned: this.getTemplateViewModel().pollHoursPinned,
            isWithTitle: this.getTemplateViewModel().isWithTitle,
            isEnabledOnHomePage: this.getTemplateViewModel().isPinnedPollEnabledOnHomePage,
            isEnabledOnArticlePage: this.getTemplateViewModel().isPinnedPollEnabledOnArticlePage,
            isEnabledOnListingPage: this.getTemplateViewModel().isPinnedPollEnabledOnListingPage
        };
    }

    public getPinnedWidgetViewModel() {
        const vm = this.getTemplateViewModel();
        const idWidget = vm.idWidget();
        return {
            widgets: idWidget == null ? [] : [{
                position: 1,
                widgetType: vm.widgetType(),
                idWidget,
                dateExpires: this.getWidgetDateExpires(),
                vignetteVariables: vm.vignetteVariables(),
                vignetteReferences: vm.vignetteReferences(),
            }],
            widgetName: vm.widgetName(),
            isEnabledOnHomePage: vm.isPinnedWidgetEnabledOnHomePage(),
            isEnabledOnArticlePage: vm.isPinnedWidgetEnabledOnArticlePage(),
            isEnabledOnListingPage: vm.isPinnedWidgetEnabledOnListingPage()
        };
    }

    public getGeneralConfigViewModel() {
        return {
            isPopularSectionEnabledOnHomePage: this.getTemplateViewModel().isPopularSectionEnabledOnHomePage,
            isPopularSectionEnabledOnArticlePage: this.getTemplateViewModel().isPopularSectionEnabledOnArticlePage,
            isPopularSectionEnabledOnListingPage: this.getTemplateViewModel().isPopularSectionEnabledOnListingPage,
            isTrendingNowSectionEnabledOnHomePage: this.getTemplateViewModel().isTrendingNowSectionEnabledOnHomePage,
            isTrendingNowSectionEnabledOnArticlePage: this.getTemplateViewModel().isTrendingNowSectionEnabledOnArticlePage,
            isTrendingNowWithTagInteractionOnArticlePage: this.getTemplateViewModel().isTrendingNowWithTagInteractionOnArticlePage,
            isTrendingNowSectionEnabledOnListingPage: this.getTemplateViewModel().isTrendingNowSectionEnabledOnListingPage
        };
    }

    public getPinnedArticleConfigViewModel() {

        const items = this.getTemplateViewModel().pinnedArticles() || [];
        const articles = items.map((it) => ({
            article: it.articleObj,
            articleId: it.articleId,
            sectionTitle: it.sectionTitle,
            alternateTitle: it.alternateTitle,
            categories: (it.categoryIds && it.categoryIds.length)
                ? it.categoryIds
                : (it.categories && it.categories.length)
                    ? it.categories.map((c) => (typeof c === 'object' ? c.id : c))
                    : []
        }));
        return {
            isEnabledOnHomePage: this.getTemplateViewModel().isPinnedArticleEnabledOnHomePage(),
            isEnabledOnArticlePage: this.getTemplateViewModel().isPinnedArticleEnabledOnArticlePage(),
            isEnabledOnListingPage: this.getTemplateViewModel().isPinnedArticleEnabledOnListingPage(),
            articles
        };
    }

    public onClickAddPinnedArticle() {
        const vm = this.getTemplateViewModel();
        const article = this.articleFilter.getArticleObj();
        const sectionTitle = vm.pinnedArticleSectionTitle();
        const alternateTitle = vm.pinnedArticleAlternateTitle();
        if (!article || !article.id) {
            if (this.caller && this.caller.triggerNotification) {
                this.caller.triggerNotification('Please choose an article before adding.');
            }
            return;
        }
        const selectedCats = vm.selectedCategories ? vm.selectedCategories() : [];
        const newItem = {
            articleId: article.id,
            articleTitle: article.title,
            articleObj: article,
            sectionTitle,
            alternateTitle,
            categories: selectedCats.slice(),
            categoryIds: selectedCats.map(function(c){ return c.id; })
        };
        const current = vm.pinnedArticles().slice();
        current.push(newItem);
        vm.pinnedArticles(current);
        vm.pinnedArticleSectionTitle('');
        vm.pinnedArticleAlternateTitle('');
        this.articleFilter.setSelectedArticle();

        this.filterCategory.setSelectedItems([]);
        this.getTemplateViewModel().selectedCategories([]);
    }

    public onClickDeletePinnedArticle(item) {
        const vm = this.getTemplateViewModel();
        const list = vm.pinnedArticles().slice();
        const idx = list.indexOf(item);
        if (idx > -1) {
            list.splice(idx, 1);
            vm.pinnedArticles(list);
        }
    }

    public setPinnedArticles(articles) {
        if (Array.isArray(articles)) {
            const allCats = this.getTemplateViewModel().categories ? this.getTemplateViewModel().categories() : [];
            const toIds = (cats: any[]): number[] => {
                if (!Array.isArray(cats)) return [];
                const ids: number[] = [];
                for (const c of cats) {
                    if (typeof c === 'number') ids.push(c);
                    else if (c && typeof c.id === 'number') ids.push(c.id);
                }
                return ids;
            };
            const toObjects = (ids: number[]) => ids.map((id) => {
                const found = allCats && allCats.find ? allCats.find((c) => c.id === id) : null;
                return found ? found : { id, name: String(id) };
            });
            const mapped = articles.map(a => {
                const ids = toIds(a.categories || a.categoryIds || []);
                return ({
                    articleId: a.article ? a.article.id : a.articleId,
                    articleTitle: a.article ? a.article.title : (a.articleTitle || ''),
                    articleObj: a.article || null,
                    sectionTitle: a.sectionTitle || '',
                    alternateTitle: a.alternateTitle || '',
                    categoryIds: ids,
                    categories: toObjects(ids)
                });
            });
            this.getTemplateViewModel().pinnedArticles(mapped);
        }
    }

    public getListingPagesConfigViewModel() {

        return {
            isPinnedListingPageEnabledOnHomePage: this.getTemplateViewModel().isPinnedListingPageEnabledOnHomePage(),
            isPinnedListingPageEnabledOnArticlePage: this.getTemplateViewModel().isPinnedListingPageEnabledOnArticlePage(),
            isPinnedListingPageEnabledOnListingPage: this.getTemplateViewModel().isPinnedListingPageEnabledOnListingPage(),
            pinnedHubPageType: this.getTemplateViewModel().pinnedHubPageType(),
            pinnedListingPages: this.getPinnedListingPages(),
            numberOfPositionLists: this.getTemplateViewModel().numberOfPositionLists(),
            pinnedCustomPages: this.getPinnedCustomPages()
        };
    }

    public setPinnedPollOptions(pinnedPoll_options) {

        this.getTemplateViewModel().pinnedPoll_options(pinnedPoll_options);
    }

    public setWidgetOptions(options) {
        const vm = this.getTemplateViewModel();
        const widgetOptions = options || [];
        vm.widgetOptions(widgetOptions);
        vm.isShowWidgetSuggestions(widgetOptions.length > 0);
    }

    protected onClickCancelPinnedPageConfig() {

        this.caller.cancelPinnedPageConfig();
    }

    protected onChangePoll(keyword: string) {

        this.caller.searchPoll(keyword);
    }

    protected onChangeWidget() {
        const vm = this.getTemplateViewModel();
        if (vm.idWidget() !== null) {
            vm.idWidget(null);
            this.setWidgetDateExpires(null);
        }
        if (vm.widgetName().length < 3) {
            vm.widgetOptions([]);
            vm.isShowWidgetSuggestions(false);
            return;
        }
        this.caller.searchWidget(vm.widgetName(), vm.widgetType());
    }

    protected onSelectedPoll() {
        const selectedPollName = this.getTemplateViewModel().pollName();
        const selectedPoll = this.getTemplateViewModel().pinnedPoll_options().find(poll => poll.name === selectedPollName);
        if (selectedPoll) {
            this.getTemplateViewModel().idPoll(selectedPoll.id);
            this.getTemplateViewModel().pollName(selectedPoll.name);
            this.getTemplateViewModel().pinnedPoll_options([]);
        }

    }

    protected onSelectedWidget() {
        const vm = this.getTemplateViewModel();
        const selected = vm.widgetOptions().find(option => option.name === vm.widgetName());
        if (!selected) {
            return;
        }
        this.selectWidget(selected);
    }

    protected selectWidget(selected: any) {
        const vm = this.getTemplateViewModel();
        vm.idWidget(selected.id);
        vm.widgetName(selected.name);
        vm.vignetteVariables(selected.variables || []);
        vm.vignetteReferences(selected.references || []);
        vm.widgetOptions([]);
        vm.isShowWidgetSuggestions(false);
        if (vm.widgetType() === 'poll' && selected.dateClosed && new Date(selected.dateClosed) > new Date()) {
            this.setWidgetDateExpires(selected.dateClosed);
        } else {
            this.setWidgetDateExpires(null);
        }
    }

    public selectSidebarVignette(vignette: any): void {
        const vm = this.getTemplateViewModel();
        vm.widgetType('vignette');
        this.selectWidget(vignette);
    }

    protected clearWidget() {
        const vm = this.getTemplateViewModel();
        vm.idWidget(null);
        vm.widgetName('');
        vm.vignetteVariables([]);
        vm.vignetteReferences([]);
        vm.widgetOptions([]);
        vm.isShowWidgetSuggestions(false);
        this.setWidgetDateExpires(null);
    }

    protected onWidgetSearchBlur() {
        window.setTimeout(() => {
            this.onSelectedWidget();
            this.getTemplateViewModel().isShowWidgetSuggestions(false);
        }, 150);
    }

    protected onWidgetTypeChanged(widgetType = null) {
        const vm = this.getTemplateViewModel();
        if (typeof widgetType === 'string') {
            vm.widgetType(widgetType);
        }
        vm.idWidget(null);
        vm.widgetName('');
        vm.vignetteVariables([]);
        vm.vignetteReferences([]);
        vm.widgetOptions([]);
        vm.isShowWidgetSuggestions(false);
        this.setWidgetDateExpires(null);
        this.updateWidgetSearchPlaceholder();
    }

    protected updateWidgetSearchPlaceholder() {
        const placeholders = {
            poll: 'Poll Name',
            quiz: 'Quiz Title',
            vignette: 'Vignette Name'
        };
        this.getTemplateViewModel().widgetSearchPlaceholder(placeholders[this.getTemplateViewModel().widgetType()] || 'Widget Name');
    }

    public buildWidgetDatePickerCalendar(): void {
        this.sidebarWidgetDatePicker.buildCalendar();
        this.setWidgetDateExpires(null);
    }

    protected getWidgetDateExpires(): string | null {
        return this.sidebarWidgetDatePicker.getTemplateViewModel().singleDatePicker() || null;
    }

    protected setWidgetDateExpires(value): void {
        this.sidebarWidgetDatePicker.setDate(this.toDatePickerValue(value));
    }

    protected toDatePickerValue(value): string | null {
        if (!value) {
            return null;
        }
        const date = new Date(String(value).replace(' ', 'T'));
        if (Number.isNaN(date.getTime())) {
            return null;
        }
        const offset = date.getTimezoneOffset() * 60000;
        return new Date(date.getTime() - offset).toISOString().slice(0, 16).replace('T', ' ');
    }

    protected onClickCancelPinnedPoll() {

        this.caller.cancelPinnedPoll();
    }

    protected onClickCancelPinnedWidget() {
        this.caller.cancelPinnedWidget();
    }

    protected onClickCancelGeneralConfig() {

    }

    protected onClickSaveGeneralConfig() {
        this.caller.saveGeneralConfig();
    }

    protected onClickDeletePinnedPoll() {

        this.getTemplateViewModel().idPoll(null);
        this.getTemplateViewModel().poll(null);
        // this.getTemplateViewModel().pollExpire(null);
        this.getTemplateViewModel().pollTimeleft(null);
    }

    protected setFilterAutocomplete(idElement, articles) {

        switch (idElement) {
            case 'articleFilter':
                this.articleFilter.setOptions(articles);
                break;
            default:
                break;
        }
    }

    protected onClickSavePinnedPoll() {

        this.caller.savePinnedPoll();
    }

    protected onClickSavePinnedWidget() {
        this.caller.savePinnedWidget();
    }

    protected onClickSavePinnedPageConfig() {

        this.caller.savePinnedPageConfig();
    }

    protected onClickCancelPinnedArticleConfig() {

        this.caller.cancelPinnedArticleConfig();
    }

    protected onClickSavePinnedArticleConfig() {

        this.caller.savePinnedArticleConfig();
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }

    public setCategoryFilterItems(categories){
        this.filterCategory.setItems(categories);
        this.getTemplateViewModel().categories(categories);
    }

    public setPinnedListingPages(listingPages) {

        const data = [];
        for (const x in listingPages) {

            const filter = new filterListingPage_template("filterShowMoreListingPage" + (x), this.getTemplateViewModel(), this.caller);
            filter.setShowDetails(true);
            filter.setPlaceholder('Show More Hub Page');

            const pinnedListingPage: HubPagePinnedHubPage = {

                id: listingPages[x].id,
                idListingPage: listingPages[x].idListingPage,
                listingPage: listingPages[x].listingPage,
                idShowMoreListingPage: listingPages[x].idShowMoreListingPage,
                showMoreListingPage: listingPages[x].showMoreListingPage,
                showMoreListingPageFilter: filter,
                position: listingPages[x].position,
                dateCreated: listingPages[x].dateCreated,
                alternateTitle: listingPages[x].alternateTitle,
                enableEdit: false
            };

            if (listingPages[x].showMoreListingPage) {

                const showMoreListingPage = listingPages[x].showMoreListingPage;
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPageObj(showMoreListingPage);
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPage(showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')');
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().idListingPage(listingPages[x].idShowMoreListingPage);
            }

            data.push(pinnedListingPage);
        }

        this.pinnedListingPages.setListingPages(data);
    }

    public getPinnedListingPages() {

        const pinnedListingPageIds = [];
        const listingPages = this.pinnedListingPages.getListingPages();

        for (let i = 0; i < listingPages.length; i++) {

            const item = {
                idListingPage: listingPages[i].idListingPage,
                idShowMoreListingPage: listingPages[i].showMoreListingPageFilter.getTemplateViewModel().idListingPage(),
                alternateTitle: listingPages[i].alternateTitle,
                position: listingPages[i].position
            };

            pinnedListingPageIds.push(item);
        }

        return pinnedListingPageIds;
    }

    public setFilterListingPagesAutoComplete(listingPages, listingPageIdElement: string): void {

        switch (listingPageIdElement) {
            case 'pinnedListingPages_filterListingPage':
                this.pinnedListingPages.listingPageFilter.setOptions(listingPages);
                break;
            case 'pinnedListingPages_filterShowMoreListingPage':
                this.pinnedListingPages.showMoreListingPageFilter.setOptions(listingPages);
                break;
            default:
                this.pinnedListingPages.filterSimpleOnAutoComplete(listingPages, listingPageIdElement);
        }
    }

    public onClickTogglePinnedCustomPageSection(show, reset = true) {

        if (show && reset) {
            const pinnedCustomPageItems = this.getTemplateViewModel().pinnedCustomPageItems();
            const numberOfPositionLists = this.getTemplateViewModel().numberOfPositionLists();
            if (pinnedCustomPageItems.length == (numberOfPositionLists * 3)) {
                this.caller.triggerNotification('Maximum custom page number reached. Please delete one to add new! ');
                return;
            }
        }

        if (reset) {
            this.getTemplateViewModel().cardEdited(null);
            this.getTemplateViewModel().customCardTitle('');
            this.getTemplateViewModel().customCardLinkoutUrl('');
            this.imageWidget.clearImage();
            if (this.caller.textAreaEditor) {
                this.caller.textAreaEditor.setData('');
            }
        }

        this.getTemplateViewModel().isAddPinnedCustomPageVisible(show);
    }

    public onClickAddPinnedCustomPageItem() {
        const vm = this.getTemplateViewModel();
        const cardEdited = vm.cardEdited();
        const pinnedCustomPageItems = vm.pinnedCustomPageItems().slice();

        const cardTitle = vm.customCardTitle();
        const cardLinkoutUrl = vm.customCardLinkoutUrl();
        const cardDescription = this.caller.textAreaEditor.getData();
        const cardImage = this.imageWidget.getImage();

        if (cardImage) {
            cardImage.uri = cardImage.url;
            cardImage.src = cardImage.url;
        }

        const newItem = {
            cardTitle,
            cardLinkoutUrl,
            cardImage,
            cardDescription
        };

        if (cardEdited) {
            const index = pinnedCustomPageItems.findIndex(c =>
                c.cardTitle === cardEdited.cardTitle &&
                c.cardLinkoutUrl === cardEdited.cardLinkoutUrl &&
                c.cardDescription === cardEdited.cardDescription
            );

            if (index > -1) {
                pinnedCustomPageItems[index] = newItem;
            } else {
                pinnedCustomPageItems.push(newItem);
            }

            vm.cardEdited(null);
        } else {
            pinnedCustomPageItems.push(newItem);
        }

        vm.pinnedCustomPageItems([]);
        vm.pinnedCustomPageItems(pinnedCustomPageItems);

        this.onClickTogglePinnedCustomPageSection(false);
    }

    public onClickDeletePinnedCustomPageItem(item) {

        const pinnedCustomPageItems = this.getTemplateViewModel().pinnedCustomPageItems();
        const index = pinnedCustomPageItems.indexOf(item);
        pinnedCustomPageItems.splice(index, 1);
        this.getTemplateViewModel().pinnedCustomPageItems([]);
        this.getTemplateViewModel().pinnedCustomPageItems(pinnedCustomPageItems);
    }

    public handleDragAndDrop(element, currentObservableArray, childrenSelector): any {

        DragAndDropHandler.handleDragAndDrop(element, currentObservableArray, childrenSelector);
    }

    public getPinnedCustomPages() {
        const items = this.getTemplateViewModel().pinnedCustomPageItems();

        const data = {
            title1: this.getTemplateViewModel().customPageTitle1(),
            title2: this.getTemplateViewModel().numberOfPositionLists() == 2 ? this.getTemplateViewModel().customPageTitle2() : '',
            moreLinkoutTitle1: this.getTemplateViewModel().customPageMoreLinkoutTitle1(),
            moreLinkoutTitle2: this.getTemplateViewModel().numberOfPositionLists() == 2 ? this.getTemplateViewModel().customPageMoreLinkoutTitle2() : '',
            moreLinkoutUrl1: this.getTemplateViewModel().customPageMoreLinkoutUrl1(),
            moreLinkoutUrl2: this.getTemplateViewModel().numberOfPositionLists() == 2 ? this.getTemplateViewModel().customPageMoreLinkoutUrl2() : '',
            items
        };

        return data;
    }

    public setPinnedCustomPages(data) {
        if (data && data.items && data.items.length > 0) {
            this.getTemplateViewModel().customPageTitle1(data.title1);
            this.getTemplateViewModel().customPageTitle2(data.title2);
            this.getTemplateViewModel().customPageMoreLinkoutTitle1(data.moreLinkoutTitle1);
            this.getTemplateViewModel().customPageMoreLinkoutTitle2(data.moreLinkoutTitle2);
            this.getTemplateViewModel().customPageMoreLinkoutUrl1(data.moreLinkoutUrl1);
            this.getTemplateViewModel().customPageMoreLinkoutUrl2(data.moreLinkoutUrl2);
            this.getTemplateViewModel().pinnedCustomPageItems(data.items);

            this.getTemplateViewModel().pinnedHubPageType('custom-pages');
            if (data.title2 != '' || data.moreLinkoutTitle2 != '' || data.moreLinkoutUrl2 != '') {
                this.getTemplateViewModel().numberOfPositionLists(2);
            }
        }
    }

    public onClickEditPinnedCustomPageItem(data) {
        this.getTemplateViewModel().cardEdited(data);
        this.getTemplateViewModel().customCardTitle(data.cardTitle);
        this.getTemplateViewModel().customCardLinkoutUrl(data.cardLinkoutUrl);
        if (data.cardImage) {
            this.imageWidget.setImage(data.cardImage);
        }
        if (this.caller.textAreaEditor) {
            this.caller.textAreaEditor.setData(data.cardDescription);
        }
        this.onClickTogglePinnedCustomPageSection(true, false);
    }

    public onClickDeleteSelectedCategory(category) {
        this.getTemplateViewModel().selectedCategories.remove((item) => item.id === category.id);
        this.filterCategory.setSelectedItems(this.getTemplateViewModel().selectedCategories());
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/configSidebar_template.ts